import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Button,
  CardActions,
  CardContent,
  CircularProgress,
  Grid,
} from "@mui/material";
import { Form, useLogin, useNotify, useSafeSetState } from "ra-core";
import { Login, TextInput } from "react-admin";
import { SubmitHandler } from "react-hook-form";

import packageJson from "../../package.json";
import { subdominio } from "../providers/simplerest/authProvider";

import { logoRednaxel } from "./RngeLogo";

const PREFIX = "RaLoginForm";

export const LoginFormClasses = {
  content: `${PREFIX}-content`,
  button: `${PREFIX}-button`,
  icon: `${PREFIX}-icon`,
};

const StyledForm = styled(Form, {
  name: PREFIX,
  overridesResolver: (props, styles) => styles.root,
})(({ theme }) => ({
  [`& .${LoginFormClasses.content}`]: {
    width: 300,
  },
  [`& .${LoginFormClasses.button}`]: {
    marginTop: theme.spacing(2),
  },
  [`& .${LoginFormClasses.icon}`]: {
    margin: theme.spacing(0.3),
  },
}));

export const LoginForm = () => {
  const [loading, setLoading] = useSafeSetState(false);
  const login = useLogin();
  const notify = useNotify();
  const [version, build] = packageJson.version.split("+");

  const submit: SubmitHandler<FieldValues> = (values) => {
    setLoading(true);
    login(values)
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        notify(
          typeof error === "string"
            ? error
            : typeof error === "undefined" || !error.message
              ? "ra.auth.sign_in_error"
              : error.message,
          {
            type: "error",
            messageArgs: {
              _:
                typeof error === "string"
                  ? error
                  : error && error.message
                    ? error.message
                    : undefined,
            },
          },
        );
      });
  };

  return (
    <Login
      avatarIcon={logoRednaxel}
      backgroundImage="https://storage.googleapis.com/rednaxel-fotos/rednaxel/3962_scm.jpg"
    >
      <StyledForm onSubmit={submit} mode="onChange" noValidate>
        {/* <CardContent className={LoginFormClasses.content}>
                    {subdominio.toUpperCase()} 4 - SCM {packageJson.version}
                </CardContent> */}
        <CardContent className={LoginFormClasses.content}>
          {/* {subdominio.toUpperCase()} 4 - WMS {packageJson.version} */}
          RNGE 4 - SCM v{version} <br />
          <span style={{ fontSize: "0.8rem" }}>
            {build && ` (build ${build})`}
          </span>
        </CardContent>

        <CardContent className={LoginFormClasses.content}>
          <TextInput
            autoFocus
            source="username"
            label="Nome de Usuário"
            autoComplete="username"
          />
          <TextInput
            source="password"
            label="Senha"
            type="password"
            autoComplete="current-password"
          />
        </CardContent>
        <CardActions sx={{ flexDirection: "column", gap: 1 }}>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={loading}
            fullWidth
            className={LoginFormClasses.button}
          >
            {loading ? (
              <CircularProgress
                className={LoginFormClasses.icon}
                size={19}
                thickness={3}
              />
            ) : (
              "Entrar"
            )}
          </Button>
        </CardActions>
      </StyledForm>
    </Login>
  );
};

type FieldValues = Record<string, any>;
